export { default } from './TMPLinkWrap';
